import { render, staticRenderFns } from "./ModalChange.vue?vue&type=template&id=e7715340&"
import script from "./ModalChange.vue?vue&type=script&lang=js&"
export * from "./ModalChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports